import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatCurrency, formatDate } from '@/utils/formatters';
import { DEFAULT_CATEGORIES } from '@/constants';

const CAT_MAP = Object.fromEntries(DEFAULT_CATEGORIES.map(c => [c.id, c]));

export default function ExpenseItem({ expense, onDelete, selectable = false, selected = false, onSelect }) {
  const navigate = useNavigate();
  const cat = CAT_MAP[expense.category];

  return (
    <div className="flex items-center gap-3 bg-white rounded-card px-3 py-2.5 shadow-sm">
      {/* Checkbox (selection mode) */}
      {selectable && (
        <input
          type="checkbox"
          checked={selected}
          onChange={() => onSelect?.(expense.id)}
          aria-label={`Select ${expense.vendor}`}
          className="w-4 h-4 accent-teal-600 flex-shrink-0"
        />
      )}

      {/* Category dot */}
      <div
        className="w-2 h-2 rounded-sm flex-shrink-0"
        style={{ background: cat?.color ?? '#9E9E9E' }}
        aria-hidden
      />

      {/* Info */}
      <div className="flex-1 min-w-0" onClick={() => !selectable && navigate(`/expenses/edit/${expense.id}`)} role={selectable ? undefined : 'button'} tabIndex={selectable ? -1 : 0}>
        <p className="text-sm font-semibold text-gray-800 truncate">{expense.vendor}</p>
        <p className="text-xs text-gray-400">
          {formatDate(expense.date)} · {cat?.label ?? expense.category}
          {expense.loggedByName ? ` · by ${expense.loggedByName}` : ''}
        </p>
      </div>

      {/* Amount + mode */}
      <div className="text-right flex-shrink-0">
        <p className="text-sm font-bold text-primary">{formatCurrency(expense.amount)}</p>
        <p className="text-xs text-gray-400">{expense.paymentMode}</p>
      </div>

      {/* Delete (hidden in selection mode) */}
      {!selectable && (
        <button
          onClick={() => onDelete(expense.id)}
          aria-label={`Delete ${expense.vendor}`}
          className="text-gray-300 hover:text-danger transition-colors ml-1"
        >
          ✕
        </button>
      )}
    </div>
  );
}
